import { render, staticRenderFns } from "./unloadShipAdd.vue?vue&type=template&id=a1a86706&"
import script from "./unloadShipAdd.vue?vue&type=script&lang=js&"
export * from "./unloadShipAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports